import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import {
  PROPOSAL_DOCUMENT_TEMPLATE_CODE,
  usePayloadRefreshDigitalSignatureStatus,
} from '../../Components/Confirmation/usePayloadRefreshDigitalSignatureStatus'
import { useDigitalSignatureSettingsStore } from '../../Stores/digitalSignature/useDigitalSignatureSettingsStore'
import { useRefreshDigitalSignatureStatusStore } from '../../Stores/useRefreshDigitalSignatureStatusStore'

export const useRefreshDigitalSignatureStatusHydration = () => {
  const { setIsSendSignature, setIsInitialSignatureClicked } =
    useDigitalSignatureSettingsStore()
  const { setIsSigned, setIsSignedResume } =
    useRefreshDigitalSignatureStatusStore()
  const { handleRefreshDigitalSignatureResume } =
    usePayloadRefreshDigitalSignatureStatus()

  const handleRefreshDigitalSignatureStatusHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const redirectionStepCodes = ['70', '71', '72', '73']

    if (redirectionStepCodes?.includes(data?.redirectionStepCode || '')) {
      const policyData = data.processData?.policyData

      if (
        data.processData?.firstReceipt?.invoiceId === null &&
        policyData?.policyStatusCode === '08' &&
        policyData.policySubStatus === 'BOO'
      ) {
        const getProposalDocumentKeyRef =
          policyData?.documentList?.find(
            (doc) => doc.templateCode === PROPOSAL_DOCUMENT_TEMPLATE_CODE,
          )?.keyRef || ''

        const getDocumentRedDoc =
          policyData?.documentList?.find(
            (doc) => doc.managementSystemCode === 'RedDoc',
          )?.id || ''

        setIsSendSignature(true)
        setIsInitialSignatureClicked(true)
        setIsSignedResume(true)
        handleRefreshDigitalSignatureResume({
          policyId: policyData?.policyId || '',
          signatureId: getDocumentRedDoc || '',
          keyRef: getProposalDocumentKeyRef,
          policyHolderFiscalNumber:
            data.entities?.policyHolder?.vatNumber || '',
          policyHolderId: data.entities?.policyHolder?.idEntity || '',
        })
      } else {
        setIsSigned(data.processData?.policyData?.policyStatusCode === '08')
      }
    }
  }

  return { handleRefreshDigitalSignatureStatusHydration }
}
